import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';
import DemoImage from './DemoImage';
import CodeSample from './CodeSample/CodeSample';
import * as Consts from '../constants';


const DIALOG_IMAGE_ID = 'dialogImage';

export default class Dialog extends Component {
  static propTypes = {
    publicId: PropTypes.string,
    transformation: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(React.PropTypes.object)
    ]),
    format: PropTypes.string,
    showDetails: PropTypes.func.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    reportImageSize: PropTypes.func.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose(e) {
    this.props.showDetails(null, null, null);
    this.props.resetDemoImage(DIALOG_IMAGE_ID);
  }

  getTitle(sizeKB) {
    let result = 'Loading...';
    if (this.props.width && this.props.height && sizeKB > 0) {
      result = `${this.props.width}x${this.props.height} JPEG, ${sizeKB}KB`;
    }
    return result;
  }

  render() {
    let img, show;
    if (this.props.transformation && this.props.publicId) {
      img = <DemoImage {...this.props} format="jpg" className="img-holder" showButton={false} id={DIALOG_IMAGE_ID} />;
      show = true;
    }

    const size = this.props.size || 0;
    const sizeKB = Math.round(size / 1024);

    let title = this.getTitle(sizeKB);
    return (
      <Modal show={show} onHide={this.handleClose} animation={false}>
        <div className="content">
          <Modal.Header closeButton>
            <h3 className="modal-title">{title}</h3>
          </Modal.Header>
          {img}
          <Modal.Body>
            {this.props.details}
          </Modal.Body>
        </div>
        {show ? <CodeSample {...this.props} cloudName={Consts.CLOUD_NAME}/> : <div />}
      </Modal>);
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/Dialog.js
 **/